<script>
	import { onMount } from "svelte";

	export let categoryName;
	export let refetch = () => {};
	export let id;
	export let idx;
	export let options = [];
	export let toggle = () => {};
	export let nonQuery = false; // For usage in non query params

	export let isOpen = false;
	let hasMounted = false;

	$: selectedCount = options.filter((option) => option.selected).length;

	function getSelectedOptions() {
		return options
			.filter((option) => option.selected)
			.map((option) => (nonQuery ? option.value : option.id));
	}

	function handleRefetch() {
		refetch({
			[id]: getSelectedOptions(),
		});
	}

	function handleClick(option) {
		const index = options.findIndex((opt) =>
			nonQuery ? opt.value === option.value : opt.id === option.id
		);
		if (index !== -1) {
			options[index].selected = !options[index].selected;
			handleRefetch();
		}
	}

	function handleClickOutside(event) {
		if (!event.target.closest(".dropdown")) {
			isOpen = false;
		}
	}

	onMount(() => {
		hasMounted = true;
		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	});
</script>

<div class="dropdown">
	<button
		type="button"
		class="form-select getgo select dc-text"
		on:click={toggle}
		>{categoryName +
			(selectedCount > 0 ? ` (${selectedCount})` : "")}</button
	>
	{#if isOpen}
		<div class="dropdown-menu">
			{#each options as option}
				<label class="dropdown-item">
					<input
						class="checkbox-item"
						type="checkbox"
						on:click={() => handleClick(option)}
						bind:checked={option.selected}
					/>
					{option.label}
				</label>
			{/each}
		</div>
	{/if}
</div>

<style>
	.dropdown {
		width: 100%;
		position: relative;
		display: inline-block;
	}

	.dropdown-menu {
		display: block;
		position: absolute;
		background-color: white;
		box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
		padding: 12px 16px;
		z-index: 9999;
		max-height: 350px;
		min-width: 100%;
		width: max-content;
		left: 0;
		right: 0;
		overflow-y: auto;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	.dropdown-item {
		height: 48px;
		width: auto;
		display: flex;
		align-items: center;
	}

	.checkbox-item {
		margin-right: 8px;
	}

	.dc-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: var(--fds-on-surface-variant);
	}
</style>
